// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.faction-godparent-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 8px;
}

.faction-godparent-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 0;
}

.faction-godparent-create-btn {
  border: 1px solid #c8d3ec;
  background: #f6f8ff;
  color: #315fb5;
  border-radius: 8px;
  padding: 4px 10px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}

.faction-godparent-create-btn:hover {
  background: #eef3ff;
}

.faction-godparent-search {
  margin-bottom: 8px;
}

.faction-godparent-suggestions {
  border: 1px solid #d7deef;
  background: #fff;
  border-radius: 8px;
  max-height: 170px;
  overflow-y: auto;
  margin-bottom: 8px;
}

.faction-godparent-suggestion-item {
  width: 100%;
  border: none;
  border-bottom: 1px solid #edf1fa;
  background: #fff;
  color: #2a3956;
  text-align: left;
  padding: 8px 10px;
  font-size: 13px;
  cursor: pointer;
}

.faction-godparent-suggestion-item:last-child {
  border-bottom: none;
}

.faction-godparent-suggestion-item:hover {
  background: #f4f8ff;
}

.faction-godparent-selected {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.faction-godparent-selected-item {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border: 1px solid #d9e1f2;
  background: #f7f9fd;
  color: #2a3956;
  border-radius: 999px;
  padding: 4px 10px;
  font-size: 12px;
  cursor: pointer;
}

.faction-godparent-selected-item:hover {
  background: #f0f4fc;
}

.faction-godparent-remove {
  color: #c4424f;
  font-weight: 700;
  line-height: 1;
}

.faction-godparent-helper {
  display: inline-block;
  color: #6a768d;
  font-size: 12px;
  margin-top: 2px;
}

.faction-save-btn {
  padding: 6px 14px;
  font-size: 13px;
  border-radius: 10px;
}

@media (max-width: 720px) {
  .faction-godparent-header {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Disciplina/factionRelationship.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":[".faction-godparent-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 8px;\n}\n\n.faction-godparent-label {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 0;\n}\n\n.faction-godparent-create-btn {\n  border: 1px solid #c8d3ec;\n  background: #f6f8ff;\n  color: #315fb5;\n  border-radius: 8px;\n  padding: 4px 10px;\n  font-size: 12px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.faction-godparent-create-btn:hover {\n  background: #eef3ff;\n}\n\n.faction-godparent-search {\n  margin-bottom: 8px;\n}\n\n.faction-godparent-suggestions {\n  border: 1px solid #d7deef;\n  background: #fff;\n  border-radius: 8px;\n  max-height: 170px;\n  overflow-y: auto;\n  margin-bottom: 8px;\n}\n\n.faction-godparent-suggestion-item {\n  width: 100%;\n  border: none;\n  border-bottom: 1px solid #edf1fa;\n  background: #fff;\n  color: #2a3956;\n  text-align: left;\n  padding: 8px 10px;\n  font-size: 13px;\n  cursor: pointer;\n}\n\n.faction-godparent-suggestion-item:last-child {\n  border-bottom: none;\n}\n\n.faction-godparent-suggestion-item:hover {\n  background: #f4f8ff;\n}\n\n.faction-godparent-selected {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.faction-godparent-selected-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  border: 1px solid #d9e1f2;\n  background: #f7f9fd;\n  color: #2a3956;\n  border-radius: 999px;\n  padding: 4px 10px;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.faction-godparent-selected-item:hover {\n  background: #f0f4fc;\n}\n\n.faction-godparent-remove {\n  color: #c4424f;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.faction-godparent-helper {\n  display: inline-block;\n  color: #6a768d;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.faction-save-btn {\n  padding: 6px 14px;\n  font-size: 13px;\n  border-radius: 10px;\n}\n\n@media (max-width: 720px) {\n  .faction-godparent-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
